import LegalPage from "../components/LegalPage";

function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="April 27, 2026"
      alternate={{ to: "/terms", label: "Terms of Service" }}
    >
      <p>
        Your privacy is a sacred trust. This Privacy Policy explains how we
        collect, use, and protect your information.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Account Information:</strong> Name, email, and general
          geographic location.
        </li>
        <li>
          <strong>User-Generated Content:</strong> Journal entries (“The
          Bridge”) and prayer logs.
        </li>
        <li>
          <strong>Growth Data:</strong> Spirit, Soul, and Body metrics and
          Scripture Vault progress.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your data to provide the Service, generate Growth Tree insights,
        and deliver Scripture-based prompts.
      </p>
      <p>
        <strong>AI Processing:</strong> Journal entries are processed by secure
        third-party AI (Google Gemini). We do NOT use your personal journal data
        to train AI models.
      </p>

      <h2>3. Barnabas Support (Absolute Social Privacy)</h2>
      <p>
        If you use this feature, your partners can only see high-level metrics
        (pillar percentages). They cannot see your journal entries, AI
        responses, or private prayer content. There is no functionality within
        the Service to share the text of your personal processing with other
        users.
      </p>

      <h2>4. Data Sharing</h2>
      <p>
        We do not sell your data. We only share data with trusted service
        providers (e.g., AWS for hosting, Google for AI) bound by strict
        confidentiality obligations.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We use industry-standard security measures, including encryption in
        transit and at rest. However, no system is 100% secure.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You have the right to access, correct, or request deletion of your data.
        You can delete your account and all associated data at any time within
        the app settings.
      </p>

      <h2>7. Sabbath Mode</h2>
      <p>
        You may enable Sabbath Mode to pause tracking, disable notifications,
        and limit data interaction during your scheduled periods of rest.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        For privacy-related inquiries:{" "}
        <a href="mailto:info@theway523.com">info@theway523.com</a>
      </p>
    </LegalPage>
  );
}

export default PrivacyPolicy;
